module.exports = __webpack_public_path__ + "img/ic_5.a140e13d.png";